import LendingInterestSettings from "@/models/Products/ProductSettings/DefaultSettings/LendingInterest/LendingInterestSettings";

export default class UpdateLendingInterestSettingsRequest extends LendingInterestSettings {
    updatedAt: Date;

    public constructor(settings: LendingInterestSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.calculationType = settings.calculationType;
            this.interestType = settings.interestType;
            this.rateType = settings.rateType;
            this.rateValue = settings.rateValue;
            this.rateValue = +this.rateValue;
            this.rateFloorValue = settings.rateFloorValue;
            this.rateFloorValue = +this.rateFloorValue;
            this.rateCeilingValue = settings.rateCeilingValue;
            this.rateCeilingValue = +this.rateCeilingValue;
            this.rateSourceId = settings.rateSourceId;
            this.rateSourceIdentifier = settings.rateSourceIdentifier;
            this.rateChargedPeriodType = settings.rateChargedPeriodType;
            this.rateChargedPeriodValue = settings.rateChargedPeriodValue;
            this.rateChargedPeriodValue = +this.rateChargedPeriodValue;
            this.accruedPeriodType = settings.accruedPeriodType;
            this.accruedPeriodValue = settings.accruedPeriodValue;
            this.accruedPeriodValue = +this.accruedPeriodValue
            this.accruedPeriodOnDayOfWeek = settings.accruedPeriodOnDayOfWeek;
            this.accruedPeriodOnDayOfMonth = settings.accruedPeriodOnDayOfMonth;
            this.accruedPeriodOnMonth = settings.accruedPeriodOnMonth;
            this.calculatedOnBalanceType = settings.calculatedOnBalanceType;
            this.postedFrequencyType = settings.postedFrequencyType;
            this.accrueAfterMaturity = settings.accrueAfterMaturity;
            this.repaymentInterestCalculationType = settings.repaymentInterestCalculationType;
            this.daysInYearType = settings.daysInYearType;
            this.nonWorkingDaysType = settings.nonWorkingDaysType;
        }
    }
}